import { useEffect, useRef } from 'react';

/**
 * Хук для отслеживания клика вне целевого элемента.
 * Принимает: функцию-обработчик, которая срабатывает при клике вне целевого элемента.
 * Возвращает: ref-ссылку, которая навешивается на целевой элемент.
 *
 * @param {function} onOutsideClick - функция обработчик события клика вне целевого элемента
 * @returns {React.MutableRefObject} - ref-ссылка для целевого элемента
 */
export const useOutsideClick = (onOutsideClick) => {
  const ref = useRef();

  useEffect(() => {
    function handleClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick(event);
      }
    }

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [onOutsideClick]);

  return ref;
};
